// Romanian formatting helpers

export function fmtNumber(value, decimals = 2) {
  if (value === null || value === undefined || value === "") return "";
  const n = typeof value === "number" ? value : parseFloat(value);
  if (isNaN(n)) return "";
  return n.toLocaleString("ro-RO", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function fmtInt(value) {
  if (value === null || value === undefined || value === "") return "";
  const n = typeof value === "number" ? value : parseInt(value, 10);
  if (isNaN(n)) return "";
  return n.toLocaleString("ro-RO");
}

// ISO YYYY-MM-DD -> DD-MM-YYYY
export function fmtDate(iso) {
  if (!iso) return "";
  const parts = String(iso).slice(0, 10).split("-");
  if (parts.length !== 3) return iso;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

const MONTHS_RO = ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Noi", "Dec"];

// YYYY-MM -> Mmm YYYY
export function fmtMonth(mk) {
  if (!mk) return "";
  const [y, m] = mk.split("-");
  return `${MONTHS_RO[parseInt(m, 10) - 1]} ${y}`;
}

export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

// Short YYYY-MM -> "Iul '26" for compact axis labels
export function fmtMonthShort(mk) {
  if (!mk) return "";
  const [y, m] = mk.split("-");
  return `${MONTHS_RO[parseInt(m, 10) - 1]} '${y.slice(2)}`;
}

// Abbreviated Romanian amount for axis labels & compact labels.
// At most 2 decimals, trailing zeros dropped: 1.4 -> "1,4 mil.", 1.05 -> "1,05 mil.",
// 700000 -> "700 mii", 350000 -> "350 mii". Ignores any extra args (Recharts passes the tick index).
export function fmtAbbrev(value) {
  if (value === null || value === undefined || value === "") return "";
  const n = typeof value === "number" ? value : parseFloat(value);
  if (isNaN(n)) return "";
  const abs = Math.abs(n);
  if (abs >= 1e6) return `${(n / 1e6).toLocaleString("ro-RO", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} mil.`;
  if (abs >= 1e3) return `${(n / 1e3).toLocaleString("ro-RO", { maximumFractionDigits: 0 })} mii`;
  return n.toLocaleString("ro-RO", { maximumFractionDigits: 0 });
}

